import type { ReactLocalization } from "@fluent/react";
import finance from "byzantine/src/finance";
import type { WireRowEdit, WireRowErrors } from "./wireRecipientReviewTypes";

export const validateWireField = (
  l10n: ReactLocalization,
  field: string,
  value: string
): string | null => {
  const trimmed = value.trim();
  if (!trimmed) {
    return l10n.getString("wire-recipient-review-validation-required");
  }
  switch (field) {
    case "account_number":
      if (!/^[a-zA-Z0-9]+$/.test(trimmed)) {
        return l10n.getString(
          "wire-recipient-review-validation-alphanumeric"
        );
      }
      if (trimmed.length > 17) {
        return l10n.getString(
          "wire-recipient-review-validation-account-max"
        );
      }
      break;
    case "routing_number":
      if (!/^\d{9}$/.test(trimmed)) {
        return l10n.getString(
          "wire-recipient-review-validation-routing-invalid"
        );
      }
      if (!finance.abaRoutingNumberIsValid(trimmed)) {
        return l10n.getString(
          "wire-recipient-review-validation-routing-invalid"
        );
      }
      break;
    default:
      break;
  }
  return null;
};

export const validateWireRow = (
  l10n: ReactLocalization,
  edit: WireRowEdit
): WireRowErrors => {
  const errors: WireRowErrors = {};
  const fields: [keyof WireRowEdit, string][] = [
    ["recipient_name", "name"],
    ["account_number", "account_number"],
    ["routing_number", "routing_number"],
    ["street_address", "street_address"],
    ["city", "city"],
    ["region_code", "region_code"],
    ["postal_code", "postal_code"],
  ];
  fields.forEach(([field, fieldKey]) => {
    const error = validateWireField(l10n, fieldKey, edit[field]);
    if (error) {
      errors[fieldKey] = error;
    }
  });
  return errors;
};
